import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { useMutableRef } from '@carnica/utils/hooks';
import { compose } from '@beef/utils';
import { MessageType } from "../../../../shared/api";
import { FSMStages, useCommunicationContext, useFSM, useSessionContext } from "../../../../shared/model";
import { EBtnTypeAnalytics, ymPushSendClickQuickButton, ymPushTapFaq } from "../../../../shared/analytics";
import { selectIsLastSessionFinished, selectIsLoadStatusSuccess } from "../../../../entities/message/model";
import { addQuickReplies as addStoreQuickReplies, selectFrequentQuestions, selectQuickReplies } from "../../../../entities/content/model";
import { selectAuthZoneConfig, selectStartButtonsConfig } from "../../../../entities/settings/model";
import { useCaptchaContext } from "../../../../entities/captcha/model";
import { TypeQuickActions } from "./types";
import { QuickRequest } from "../QuickRequest";
import { QuickReplies } from "../QuickReplies";
var callbackConverter = function callbackConverter(callback) {
  return function (item) {
    return callback({
      link: item.deepLink ? item.deepLink : item.link,
      title: item.text,
      imageUrl: item.imageUrl,
      isDeepLink: !!item.deepLink,
      value: item === null || item === void 0 ? void 0 : item.value
    });
  };
};
var QuickActionsRender = function QuickActionsRender(_ref) {
  var faqPopularRequests = _ref.faqPopularRequests,
    faqQuickReplies = _ref.faqQuickReplies,
    className = _ref.className,
    zoneType = _ref.zoneType,
    nzStartButtons = _ref.nzStartButtons,
    addQuickReplies = _ref.addQuickReplies,
    isLastSessionFinished = _ref.isLastSessionFinished;
  var sendMessageRef = useMutableRef(useCommunicationContext().sendMessage);
  var _useFSM = useFSM(),
    stage = _useFSM.stage;
  var _useSessionContext = useSessionContext(),
    sessions = _useSessionContext.sessions;
  var _useCaptchaContext = useCaptchaContext(),
    captchaStage = _useCaptchaContext.captchaStage;
  var typeQuickActions = useMemo(function () {
    if (zoneType === 'unauthorized' && (
    // Предохранение на случай если captchaStage будет в инициализаци, но КА будет уже в активном состоянии
    captchaStage === 'init' && stage === FSMStages.CAPTCHA_NEEDED || isLastSessionFinished) && !!(nzStartButtons !== null && nzStartButtons !== void 0 && nzStartButtons.length)) {
      return TypeQuickActions.NZStart;
    }
    if (zoneType === 'authorized' && (isLastSessionFinished || !sessions.length) && !!faqPopularRequests.length) {
      return TypeQuickActions.PopularRequests;
    }
    if (!!faqQuickReplies.length && !isLastSessionFinished) {
      return TypeQuickActions.QuickReplies;
    }
    return TypeQuickActions.Hidden;
  }, [isLastSessionFinished, sessions, faqPopularRequests, captchaStage, faqQuickReplies, zoneType, nzStartButtons, stage]);
  var onItemClick = useCallback(function (_ref2) {
    var link = _ref2.link,
      value = _ref2.value,
      title = _ref2.title;
    if (!link || typeQuickActions === TypeQuickActions.QuickReplies) {
      var btnOptionBase = value ? {
        messageType: MessageType.Button,
        value: value
      } : undefined;
      var btnOptionDeepLink = {
        messageType: MessageType.Link,
        link: link
      };
      sendMessageRef.current(title, undefined, undefined, link ? btnOptionDeepLink : btnOptionBase);
    } else {
      addQuickReplies([]);
    }
    if (typeQuickActions === TypeQuickActions.QuickReplies) {
      ymPushSendClickQuickButton(title, EBtnTypeAnalytics.replies, zoneType);
      return;
    }
    ymPushTapFaq(title);
    ymPushSendClickQuickButton(title, EBtnTypeAnalytics.popular, zoneType);
  }, [typeQuickActions]);
  if (typeQuickActions === TypeQuickActions.Hidden) {
    return null;
  }
  if (typeQuickActions === TypeQuickActions.QuickReplies) {
    return /*#__PURE__*/React.createElement(QuickReplies, {
      className: className,
      items: faqQuickReplies,
      onItemClick: callbackConverter(onItemClick),
      "data-t-id": "ui-QuickActions"
    });
  }
  return /*#__PURE__*/React.createElement(QuickRequest, {
    className: className,
    items: typeQuickActions === TypeQuickActions.NZStart ? nzStartButtons : faqPopularRequests,
    onItemClick: onItemClick,
    zoneType: zoneType
  });
};
var mapStateToProps = function mapStateToProps(store) {
  var startButtonsConfig = selectStartButtonsConfig(store);
  var _selectAuthZoneConfig = selectAuthZoneConfig(store),
    zoneType = _selectAuthZoneConfig.zoneType;
  return {
    nzStartButtons: startButtonsConfig !== null && startButtonsConfig !== void 0 && startButtonsConfig.isEnabled ? startButtonsConfig.list : [],
    faqPopularRequests: selectFrequentQuestions(store),
    faqQuickReplies: selectQuickReplies(store),
    isLastSessionFinished: selectIsLastSessionFinished(store),
    zoneType: zoneType,
    shouldRender: zoneType === 'authorized' ? selectIsLoadStatusSuccess(store) : !!(startButtonsConfig !== null && startButtonsConfig !== void 0 && startButtonsConfig.isEnabled && startButtonsConfig.list.length)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addQuickReplies: function addQuickReplies(list) {
      return dispatch(addStoreQuickReplies(list));
    }
  };
};
export var QuickActions = compose(connect(mapStateToProps, mapDispatchToProps))(QuickActionsRender);